/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getTeam = /* GraphQL */ `
  query GetTeam($id: ID!) {
    getTeam(id: $id) {
      id
      name
      tenantId
      fieldId
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      isDeleted
      aws_ds
      allowedTaskTypeCreateGroups {
        id
        name
      }
    }
  }
`;
export const getTeamsByTeamIds = /* GraphQL */ `
  query GetTeamsByTeamIds($size: Int, $teamIds: [ID]) {
    getTeamsByTeamIds(size: $size, teamIds: $teamIds) {
      id
      name
      tenantId
      fieldId
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      isDeleted
      aws_ds
      allowedTaskTypeCreateGroups {
        id
        name
      }
    }
  }
`;
export const getAssetByAreas = /* GraphQL */ `
  query GetAssetByAreas($size: Int, $areas: [String]) {
    getAssetByAreas(size: $size, areas: $areas) {
      id
      tenantId
      fieldId
      xid
      fdgxid
      cxid
      sourceSystem
      name
      type
      subType
      areas {
        areaId
        isDeleted
      }
      teams {
        teamId
        resources {
          userId
          resourceLevel
          isDeleted
        }
        isDeleted
      }
      routes
      fdgRouteId
      fdgRouteIds
      fdgObjectId
      stopId
      stop {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      latitude
      longitude
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      aws_ds
      isDeleted
      areaType
      areaDefinition {
        version
        criteria {
          attributeName
          values
        }
      }
      customAttributes
      bulkStopGroupName
      producingMethodId
      productType
      tankStrappingID
      attachments {
        bucket
        key
        region
        fileName
      }
      watchers
      contacts
      preferredLocations
      geofence
      additionalStopIds
      hierarchy
    }
  }
`;
export const getDeltaAssetByAreas = /* GraphQL */ `
  query GetDeltaAssetByAreas(
    $size: Int
    $areas: [String]
    $lastSync: AWSTimestamp
  ) {
    getDeltaAssetByAreas(size: $size, areas: $areas, lastSync: $lastSync) {
      id
      tenantId
      fieldId
      xid
      fdgxid
      cxid
      sourceSystem
      name
      type
      subType
      areas {
        areaId
        isDeleted
      }
      teams {
        teamId
        resources {
          userId
          resourceLevel
          isDeleted
        }
        isDeleted
      }
      routes
      fdgRouteId
      fdgRouteIds
      fdgObjectId
      stopId
      stop {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      latitude
      longitude
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      aws_ds
      isDeleted
      areaType
      areaDefinition {
        version
        criteria {
          attributeName
          values
        }
      }
      customAttributes
      bulkStopGroupName
      producingMethodId
      productType
      tankStrappingID
      attachments {
        bucket
        key
        region
        fileName
      }
      watchers
      contacts
      preferredLocations
      geofence
      additionalStopIds
      hierarchy
    }
  }
`;
export const getAsset = /* GraphQL */ `
  query GetAsset($id: String!) {
    getAsset(id: $id) {
      id
      tenantId
      fieldId
      xid
      fdgxid
      cxid
      sourceSystem
      name
      type
      subType
      areas {
        areaId
        isDeleted
      }
      teams {
        teamId
        resources {
          userId
          resourceLevel
          isDeleted
        }
        isDeleted
      }
      routes
      fdgRouteId
      fdgRouteIds
      fdgObjectId
      stopId
      stop {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      latitude
      longitude
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      aws_ds
      isDeleted
      areaType
      areaDefinition {
        version
        criteria {
          attributeName
          values
        }
      }
      customAttributes
      bulkStopGroupName
      producingMethodId
      productType
      tankStrappingID
      attachments {
        bucket
        key
        region
        fileName
      }
      watchers
      contacts
      preferredLocations
      geofence
      additionalStopIds
      hierarchy
    }
  }
`;
export const getComment = /* GraphQL */ `
  query GetComment($id: ID!) {
    getComment(id: $id) {
      assets
      attachments {
        bucket
        key
        region
        fileName
      }
      comment
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      fieldId
      id
      taskId
      assetId
      tenantId
      users
      isDeleted
      autoGenerated
    }
  }
`;
export const getDistanceMatrix = /* GraphQL */ `
  query GetDistanceMatrix($id: String!) {
    getDistanceMatrix(id: $id) {
      id
      distance
      duration
      fieldId
      startGeoLocationId
      endGeoLocationId
      startStopId
      endStopId
      tenantId
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      isDeleted
    }
  }
`;
export const getFeed = /* GraphQL */ `
  query GetFeed($id: ID!) {
    getFeed(id: $id) {
      data
      fieldId
      id
      tenantId
      userId
      areaIds
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      isDeleted
    }
  }
`;
export const getSettings = /* GraphQL */ `
  query GetSettings($id: ID!) {
    getSettings(id: $id) {
      id
      admin
      common
      app
      settings
      mapTilerSettings
      runEngineSettings
      automateDailyRunSettings
      featureFlags
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      created_at
      created_by
      updated_at
      updated_by
      tenantAuthCache
      fdgsssidCache
    }
  }
`;
export const getTaskById = /* GraphQL */ `
  query GetTaskById($id: ID!) {
    getTaskById(id: $id) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const getTaskType = /* GraphQL */ `
  query GetTaskType($id: ID!) {
    getTaskType(id: $id) {
      id
      duration
      priority
      score
      increment
      name
      schema
      teamId
      tenantId
      fieldId
      isParent
      autoApprove
      workflowVersions {
        version
        workflowSteps {
          workflowStepId
          taskTypeId
          dependsOn
          immediateNextTo
          sameAssigneeAs
          sameStartTimeAs
          formSectionId
          preferredLocationTypeId
          priorityTemplate
          assigneeIds
          sameLocationAs
          autoResolveDependsOn
        }
      }
      publishedVersion
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      isDeleted
      needAcceptance
      enforceTimeSpent
      enforceComment
      enableReassign
      enableAutoAssign
      hasFormAttributes
      isLinkable
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      resolveOnArchive
      partsPicklist
      formSchemaId
      approvalMatrix
      disableCreateOnMobile
      disableAssignOnMobile
      disablePriorityOnMobile
      disableWorkOrderOnMobile
      disableDateOnMobile
      filterDraftTasksOnMobile
      disableAssetOnMobile
      resolveOnGeofence
      excludeByRoutingEngine
      disablePrioritySelectionOnMobile
      disableEditingResolvedOnMobile
      taskTypeCode
      generateMultiple
      globalAttributes
      reminder {
        enableReminder
        reminderTime {
          days
          hours
          minutes
        }
      }
      attachmentIds
      instructionIds
      notification {
        notificationProfile
        notificationConfig {
          actionType
          userTypeForEmail
          userTypeForPushNotification
          sectionsToIncludeInEmail
        }
      }
      notificationProfile
      actionsEnabled
      userType
      fullManualMode
      singleActiveTask
      mandatoryWatcherGroups
      priorityTemplate
      priorityAlias
      rt_id
      needEquipment
      mandatoryAssignee
      autoAssignFirstChildToCreator
      triggerTasksUsingRules
      groups {
        id
        name
      }
      watcherGroupConfig {
        entityId
        entityPicklistWatcherGroupMappingId
        entityType
      }
      generateMultipleLabelName
      isDynamicParentChild
      rollupGlobalAttributes
      allowAssetLevelsInfo
      allowTaskCreationWithResolvedStatus
      autoResolveFirstTask
      defaultLocationTask
      allowedTeamsAsWatchers
    }
  }
`;

export const getFactorsByType = /* GraphQL */ `
  query getFactorsByType($type: String!, $tenantId: String!,$fieldId: String!, $size: Int) {
    getFactorsByType(type: $type, tenantId: $tenantId,fieldId: $fieldId, size: $size) {
      createdBy
      createdOn
      description
      displayName
      excludedTaskTypes
      hasMatrix
      id
      isActive
      isDeleted
      modifiedBy
      modifiedOn
      tenantId
      fieldId
      type
      scoreMatrix {
        factors
        formula
        priorityMatrix
      }
      stopLevel {
        categoryMatrix
        formula
        globalAttributes
      }
      name
      assetLevel {
        categoryMatrix
        formula
        globalAttributes
      }
    }
  }
`;

export const getFactorById = /* GraphQL */ `
  query getFactorById($id: ID!) {
    getFactorById(id: $id) {
      createdBy
      createdOn
      description
      displayName
      excludedTaskTypes
      excludedTaskTypeGroups
      hasMatrix
      id
      isActive
      isDeleted
      modifiedBy
      modifiedOn
      tenantId
      type
      scoreMatrix {
        factors
        formula
        priorityMatrix
      }
      stopLevel {
        categoryMatrix
        formula
        globalAttributes
      }
      name
      assetLevel {
        categoryMatrix
        formula
        globalAttributes
      }
    }
  }
`;

export const getTenant = /* GraphQL */ `
  query GetTenant($id: ID!) {
    getTenant(id: $id) {
      id
      name
      created_at
      created_by
      updated_at
      updated_by
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      xid
      sourceSystem
      tenantId
      fieldId
      userName
      firstName
      lastName
      email
      phone
      deviceId
      startLatitude
      startLongitude
      endLatitude
      endLongitude
      currentLatitude
      currentLongitude
      shiftStartTime
      shiftEndTime
      startStopId
      endStopId
      contractHourlyRate
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      activityStatus
      hitch {
        hitchStartDate
        hitchPattern {
          hitchWorkDays
          hitchOffDays
          sortOrder
        }
      }
      teams {
        userId
        teamId
        isDeleted
        isTeamLead
        isTeamMember
      }
      roles {
        userId
        roleId
        isDeleted
      }
      contacts
      defaultContact
      offDays
      onDays
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      isDeleted
      timeZone
      aws_ds
      locationUpdatedOn
      deviceMetadata
      vendorId
      aclQualifiedId
      contractInfoId
      businessTitle
      joyn2Roles
      signatureObject {
        bucket
        key
        region
        fileName
      }
      approver
      iscreatedFromFSM
      cognitoUserName
      mobileSettings
      isEquipmentResource
      operatorId
      accessCreatedBy
      shareCreatedWith
      allowReassignmentOnMobile
    }
  }
`;
export const getUserAreas = /* GraphQL */ `
  query GetUserAreas($id: ID!) {
    getUserAreas(id: $id)
  }
`;
export const getEntityAttribute = /* GraphQL */ `
  query GetEntityAttribute($id: ID!, $tenantId: String!) {
    getEntityAttribute(id: $id, tenantId: $tenantId) {
      id
      tenantId
      xid
      sourceSystem
      attributeDisplayName
      assetType
      attributeType
      attributeName
      isDeleted
    }
  }
`;
export const listTaskTypes = /* GraphQL */ `
  query ListTaskTypes(
    $filter: TableTaskTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      total
      items {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      nextToken
    }
  }
`;
export const getUserByAreas = /* GraphQL */ `
  query GetUserByAreas($size: Int, $areas: [String]) {
    getUserByAreas(size: $size, areas: $areas) {
      id
      xid
      sourceSystem
      tenantId
      fieldId
      userName
      firstName
      lastName
      email
      phone
      deviceId
      startLatitude
      startLongitude
      endLatitude
      endLongitude
      currentLatitude
      currentLongitude
      shiftStartTime
      shiftEndTime
      startStopId
      endStopId
      contractHourlyRate
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      activityStatus
      hitch {
        hitchStartDate
        hitchPattern {
          hitchWorkDays
          hitchOffDays
          sortOrder
        }
      }
      teams {
        userId
        teamId
        isDeleted
        isTeamLead
        isTeamMember
      }
      roles {
        userId
        roleId
        isDeleted
      }
      contacts
      defaultContact
      offDays
      onDays
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      isDeleted
      timeZone
      aws_ds
      locationUpdatedOn
      deviceMetadata
      vendorId
      aclQualifiedId
      contractInfoId
      businessTitle
      joyn2Roles
      signatureObject {
        bucket
        key
        region
        fileName
      }
      approver
      iscreatedFromFSM
      cognitoUserName
      mobileSettings
      isEquipmentResource
      operatorId
      accessCreatedBy
      shareCreatedWith
      allowReassignmentOnMobile
    }
  }
`;
export const getDeltaUserByAreas = /* GraphQL */ `
  query GetDeltaUserByAreas(
    $size: Int
    $areas: [String]
    $lastSync: AWSTimestamp
  ) {
    getDeltaUserByAreas(size: $size, areas: $areas, lastSync: $lastSync) {
      id
      xid
      sourceSystem
      tenantId
      fieldId
      userName
      firstName
      lastName
      email
      phone
      deviceId
      startLatitude
      startLongitude
      endLatitude
      endLongitude
      currentLatitude
      currentLongitude
      shiftStartTime
      shiftEndTime
      startStopId
      endStopId
      contractHourlyRate
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      activityStatus
      hitch {
        hitchStartDate
        hitchPattern {
          hitchWorkDays
          hitchOffDays
          sortOrder
        }
      }
      teams {
        userId
        teamId
        isDeleted
        isTeamLead
        isTeamMember
      }
      roles {
        userId
        roleId
        isDeleted
      }
      contacts
      defaultContact
      offDays
      onDays
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      isDeleted
      timeZone
      aws_ds
      locationUpdatedOn
      deviceMetadata
      vendorId
      aclQualifiedId
      contractInfoId
      businessTitle
      joyn2Roles
      signatureObject {
        bucket
        key
        region
        fileName
      }
      approver
      iscreatedFromFSM
      cognitoUserName
      mobileSettings
      isEquipmentResource
      operatorId
      accessCreatedBy
      shareCreatedWith
      allowReassignmentOnMobile
    }
  }
`;
export const getAreasByTeams = /* GraphQL */ `
  query GetAreasByTeams($size: Int, $teams: [String], $tenantId: String) {
    getAreasByTeams(size: $size, teams: $teams, tenantId: $tenantId) {
      id
      tenantId
      fieldId
      xid
      fdgxid
      cxid
      sourceSystem
      name
      type
      subType
      areas {
        areaId
        isDeleted
      }
      teams {
        teamId
        resources {
          userId
          resourceLevel
          isDeleted
        }
        isDeleted
      }
      routes
      fdgRouteId
      fdgRouteIds
      fdgObjectId
      stopId
      stop {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      latitude
      longitude
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      aws_ds
      isDeleted
      areaType
      areaDefinition {
        version
        criteria {
          attributeName
          values
        }
      }
      customAttributes
      bulkStopGroupName
      producingMethodId
      productType
      tankStrappingID
      attachments {
        bucket
        key
        region
        fileName
      }
      watchers
      contacts
      preferredLocations
      geofence
      additionalStopIds
      hierarchy
    }
  }
`;
export const getUsersByTeams = /* GraphQL */ `
  query GetUsersByTeams($size: Int, $teams: [String], $tenantId: String) {
    getUsersByTeams(size: $size, teams: $teams, tenantId: $tenantId) {
      id
      xid
      sourceSystem
      tenantId
      fieldId
      userName
      firstName
      lastName
      email
      phone
      deviceId
      startLatitude
      startLongitude
      endLatitude
      endLongitude
      currentLatitude
      currentLongitude
      shiftStartTime
      shiftEndTime
      startStopId
      endStopId
      contractHourlyRate
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      activityStatus
      hitch {
        hitchStartDate
        hitchPattern {
          hitchWorkDays
          hitchOffDays
          sortOrder
        }
      }
      teams {
        userId
        teamId
        isDeleted
        isTeamLead
        isTeamMember
      }
      roles {
        userId
        roleId
        isDeleted
      }
      contacts
      defaultContact
      offDays
      onDays
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      isDeleted
      timeZone
      aws_ds
      locationUpdatedOn
      deviceMetadata
      vendorId
      aclQualifiedId
      contractInfoId
      businessTitle
      joyn2Roles
      signatureObject {
        bucket
        key
        region
        fileName
      }
      approver
      iscreatedFromFSM
      cognitoUserName
      mobileSettings
      isEquipmentResource
      operatorId
      accessCreatedBy
      shareCreatedWith
      allowReassignmentOnMobile
    }
  }
`;
export const getUsersByRoles = /* GraphQL */ `
  query GetUsersByRoles($size: Int, $roles: [String]) {
    getUsersByRoles(size: $size, roles: $roles) {
      id
      xid
      sourceSystem
      tenantId
      fieldId
      userName
      firstName
      lastName
      email
      phone
      deviceId
      startLatitude
      startLongitude
      endLatitude
      endLongitude
      currentLatitude
      currentLongitude
      shiftStartTime
      shiftEndTime
      startStopId
      endStopId
      contractHourlyRate
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      activityStatus
      hitch {
        hitchStartDate
        hitchPattern {
          hitchWorkDays
          hitchOffDays
          sortOrder
        }
      }
      teams {
        userId
        teamId
        isDeleted
        isTeamLead
        isTeamMember
      }
      roles {
        userId
        roleId
        isDeleted
      }
      contacts
      defaultContact
      offDays
      onDays
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      isDeleted
      timeZone
      aws_ds
      locationUpdatedOn
      deviceMetadata
      vendorId
      aclQualifiedId
      contractInfoId
      businessTitle
      joyn2Roles
      signatureObject {
        bucket
        key
        region
        fileName
      }
      approver
      iscreatedFromFSM
      cognitoUserName
      mobileSettings
      isEquipmentResource
      operatorId
      accessCreatedBy
      shareCreatedWith
      allowReassignmentOnMobile
    }
  }
`;
export const getUsersByField = /* GraphQL */ `
  query GetUsersByField($size: Int, $fieldId: String) {
    getUsersByField(size: $size, fieldId: $fieldId) {
      id
      xid
      sourceSystem
      tenantId
      fieldId
      userName
      firstName
      lastName
      email
      phone
      deviceId
      startLatitude
      startLongitude
      endLatitude
      endLongitude
      currentLatitude
      currentLongitude
      shiftStartTime
      shiftEndTime
      startStopId
      endStopId
      contractHourlyRate
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      activityStatus
      hitch {
        hitchStartDate
        hitchPattern {
          hitchWorkDays
          hitchOffDays
          sortOrder
        }
      }
      teams {
        userId
        teamId
        isDeleted
        isTeamLead
        isTeamMember
      }
      roles {
        userId
        roleId
        isDeleted
      }
      contacts
      defaultContact
      offDays
      onDays
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      isDeleted
      timeZone
      aws_ds
      locationUpdatedOn
      deviceMetadata
      vendorId
      aclQualifiedId
      contractInfoId
      businessTitle
      joyn2Roles
      signatureObject {
        bucket
        key
        region
        fileName
      }
      approver
      iscreatedFromFSM
      cognitoUserName
      mobileSettings
      isEquipmentResource
      operatorId
      accessCreatedBy
      shareCreatedWith
      allowReassignmentOnMobile
    }
  }
`;
export const getUserByUserName = /* GraphQL */ `
  query GetUserByUserName($userName: String!) {
    getUserByUserName(userName: $userName) {
      id
      xid
      sourceSystem
      tenantId
      fieldId
      userName
      firstName
      lastName
      email
      phone
      deviceId
      startLatitude
      startLongitude
      endLatitude
      endLongitude
      currentLatitude
      currentLongitude
      shiftStartTime
      shiftEndTime
      startStopId
      endStopId
      contractHourlyRate
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      activityStatus
      hitch {
        hitchStartDate
        hitchPattern {
          hitchWorkDays
          hitchOffDays
          sortOrder
        }
      }
      teams {
        userId
        teamId
        isDeleted
        isTeamLead
        isTeamMember
      }
      roles {
        userId
        roleId
        isDeleted
      }
      contacts
      defaultContact
      offDays
      onDays
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      isDeleted
      timeZone
      aws_ds
      locationUpdatedOn
      deviceMetadata
      vendorId
      aclQualifiedId
      contractInfoId
      businessTitle
      joyn2Roles
      signatureObject {
        bucket
        key
        region
        fileName
      }
      approver
      iscreatedFromFSM
      cognitoUserName
      mobileSettings
      isEquipmentResource
      operatorId
      accessCreatedBy
      shareCreatedWith
      allowReassignmentOnMobile
    }
  }
`;
export const getAssetsByFieldAndTypes = /* GraphQL */ `
  query GetAssetsByFieldAndTypes(
    $size: Int
    $fieldId: String!
    $types: [String]
  ) {
    getAssetsByFieldAndTypes(size: $size, fieldId: $fieldId, types: $types) {
      id
      tenantId
      fieldId
      xid
      fdgxid
      cxid
      sourceSystem
      name
      type
      subType
      areas {
        areaId
        isDeleted
      }
      teams {
        teamId
        resources {
          userId
          resourceLevel
          isDeleted
        }
        isDeleted
      }
      routes
      fdgRouteId
      fdgRouteIds
      fdgObjectId
      stopId
      stop {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      latitude
      longitude
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      aws_ds
      isDeleted
      areaType
      areaDefinition {
        version
        criteria {
          attributeName
          values
        }
      }
      customAttributes
      bulkStopGroupName
      producingMethodId
      productType
      tankStrappingID
      attachments {
        bucket
        key
        region
        fileName
      }
      watchers
      contacts
      preferredLocations
      geofence
      additionalStopIds
      hierarchy
    }
  }
`;
export const getAssetByAreasAndTypes = /* GraphQL */ `
  query GetAssetByAreasAndTypes(
    $size: Int
    $areas: [String]
    $types: [String]
  ) {
    getAssetByAreasAndTypes(size: $size, areas: $areas, types: $types) {
      id
      tenantId
      fieldId
      xid
      fdgxid
      cxid
      sourceSystem
      name
      type
      subType
      areas {
        areaId
        isDeleted
      }
      teams {
        teamId
        resources {
          userId
          resourceLevel
          isDeleted
        }
        isDeleted
      }
      routes
      fdgRouteId
      fdgRouteIds
      fdgObjectId
      stopId
      stop {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      latitude
      longitude
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      aws_ds
      isDeleted
      areaType
      areaDefinition {
        version
        criteria {
          attributeName
          values
        }
      }
      customAttributes
      bulkStopGroupName
      producingMethodId
      productType
      tankStrappingID
      attachments {
        bucket
        key
        region
        fileName
      }
      watchers
      contacts
      preferredLocations
      geofence
      additionalStopIds
      hierarchy
    }
  }
`;
export const getUserByIds = /* GraphQL */ `
  query GetUserByIds($size: Int, $userIds: [String]) {
    getUserByIds(size: $size, userIds: $userIds) {
      id
      xid
      sourceSystem
      tenantId
      fieldId
      userName
      firstName
      lastName
      email
      phone
      deviceId
      startLatitude
      startLongitude
      endLatitude
      endLongitude
      currentLatitude
      currentLongitude
      shiftStartTime
      shiftEndTime
      startStopId
      endStopId
      contractHourlyRate
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      activityStatus
      hitch {
        hitchStartDate
        hitchPattern {
          hitchWorkDays
          hitchOffDays
          sortOrder
        }
      }
      teams {
        userId
        teamId
        isDeleted
        isTeamLead
        isTeamMember
      }
      roles {
        userId
        roleId
        isDeleted
      }
      contacts
      defaultContact
      offDays
      onDays
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      isDeleted
      timeZone
      aws_ds
      locationUpdatedOn
      deviceMetadata
      vendorId
      aclQualifiedId
      contractInfoId
      businessTitle
      joyn2Roles
      signatureObject {
        bucket
        key
        region
        fileName
      }
      approver
      iscreatedFromFSM
      cognitoUserName
      mobileSettings
      isEquipmentResource
      operatorId
      accessCreatedBy
      shareCreatedWith
      allowReassignmentOnMobile
    }
  }
`;
export const getAssetsByStopAndTypes = /* GraphQL */ `
  query GetAssetsByStopAndTypes(
    $size: Int
    $stopId: String!
    $types: [String]
  ) {
    getAssetsByStopAndTypes(size: $size, stopId: $stopId, types: $types) {
      id
      tenantId
      fieldId
      xid
      fdgxid
      cxid
      sourceSystem
      name
      type
      subType
      areas {
        areaId
        isDeleted
      }
      teams {
        teamId
        resources {
          userId
          resourceLevel
          isDeleted
        }
        isDeleted
      }
      routes
      fdgRouteId
      fdgRouteIds
      fdgObjectId
      stopId
      stop {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      latitude
      longitude
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      aws_ds
      isDeleted
      areaType
      areaDefinition {
        version
        criteria {
          attributeName
          values
        }
      }
      customAttributes
      bulkStopGroupName
      producingMethodId
      productType
      tankStrappingID
      attachments {
        bucket
        key
        region
        fileName
      }
      watchers
      contacts
      preferredLocations
      geofence
      additionalStopIds
      hierarchy
    }
  }
`;
export const getAssetsByTeamsAndTypes = /* GraphQL */ `
  query GetAssetsByTeamsAndTypes(
    $size: Int
    $teams: [String]
    $types: [String]
  ) {
    getAssetsByTeamsAndTypes(size: $size, teams: $teams, types: $types) {
      id
      tenantId
      fieldId
      xid
      fdgxid
      cxid
      sourceSystem
      name
      type
      subType
      areas {
        areaId
        isDeleted
      }
      teams {
        teamId
        resources {
          userId
          resourceLevel
          isDeleted
        }
        isDeleted
      }
      routes
      fdgRouteId
      fdgRouteIds
      fdgObjectId
      stopId
      stop {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      latitude
      longitude
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      aws_ds
      isDeleted
      areaType
      areaDefinition {
        version
        criteria {
          attributeName
          values
        }
      }
      customAttributes
      bulkStopGroupName
      producingMethodId
      productType
      tankStrappingID
      attachments {
        bucket
        key
        region
        fileName
      }
      watchers
      contacts
      preferredLocations
      geofence
      additionalStopIds
      hierarchy
    }
  }
`;
export const getFields = /* GraphQL */ `
  query GetFields {
    getFields {
      id
      tenantId
      fieldId
      xid
      fdgxid
      cxid
      sourceSystem
      name
      type
      subType
      areas {
        areaId
        isDeleted
      }
      teams {
        teamId
        resources {
          userId
          resourceLevel
          isDeleted
        }
        isDeleted
      }
      routes
      fdgRouteId
      fdgRouteIds
      fdgObjectId
      stopId
      stop {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      latitude
      longitude
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      aws_ds
      isDeleted
      areaType
      areaDefinition {
        version
        criteria {
          attributeName
          values
        }
      }
      customAttributes
      bulkStopGroupName
      producingMethodId
      productType
      tankStrappingID
      attachments {
        bucket
        key
        region
        fileName
      }
      watchers
      contacts
      preferredLocations
      geofence
      additionalStopIds
      hierarchy
    }
  }
`;
export const getTasksByAreas = /* GraphQL */ `
  query GetTasksByAreas(
    $size: Int
    $areas: [String]
    $startTime: AWSTimestamp
  ) {
    getTasksByAreas(size: $size, areas: $areas, startTime: $startTime) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const getDeltaTasksByAreas = /* GraphQL */ `
  query GetDeltaTasksByAreas(
    $size: Int
    $areas: [String]
    $lastSync: AWSTimestamp
  ) {
    getDeltaTasksByAreas(size: $size, areas: $areas, lastSync: $lastSync) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const getTasksByField = /* GraphQL */ `
  query GetTasksByField(
    $size: Int
    $fieldId: String
    $startTime: AWSTimestamp
  ) {
    getTasksByField(size: $size, fieldId: $fieldId, startTime: $startTime) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const getDeltaTasksByField = /* GraphQL */ `
  query GetDeltaTasksByField(
    $size: Int
    $fieldId: String
    $lastSync: AWSTimestamp
  ) {
    getDeltaTasksByField(size: $size, fieldId: $fieldId, lastSync: $lastSync) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const getTasksByUsers = /* GraphQL */ `
  query GetTasksByUsers(
    $size: Int
    $users: [String]
    $startTime: AWSTimestamp
  ) {
    getTasksByUsers(size: $size, users: $users, startTime: $startTime) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const getDeltaTasksByUsers = /* GraphQL */ `
  query GetDeltaTasksByUsers(
    $size: Int
    $users: [String]
    $lastSync: AWSTimestamp
  ) {
    getDeltaTasksByUsers(size: $size, users: $users, lastSync: $lastSync) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const getTasksByTaskTypeIds = /* GraphQL */ `
  query GetTasksByTaskTypeIds(
    $size: Int
    $taskTypeIds: [String]
    $startTime: AWSTimestamp
  ) {
    getTasksByTaskTypeIds(
      size: $size
      taskTypeIds: $taskTypeIds
      startTime: $startTime
    ) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const getTasksByAssetId = /* GraphQL */ `
  query GetTasksByAssetId(
    $size: Int
    $assetId: String!
    $startTime: AWSTimestamp
  ) {
    getTasksByAssetId(size: $size, assetId: $assetId, startTime: $startTime) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const getDeltaTasksByAssetId = /* GraphQL */ `
  query GetDeltaTasksByAssetId(
    $size: Int
    $assetId: String!
    $lastSync: AWSTimestamp
  ) {
    getDeltaTasksByAssetId(
      size: $size
      assetId: $assetId
      lastSync: $lastSync
    ) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const getTasksByAssets = /* GraphQL */ `
  query GetTasksByAssets(
    $size: Int
    $assets: [String]
    $startTime: AWSTimestamp
  ) {
    getTasksByAssets(size: $size, assets: $assets, startTime: $startTime) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const getCommentsByTaskId = /* GraphQL */ `
  query GetCommentsByTaskId($size: Int, $taskId: String!) {
    getCommentsByTaskId(size: $size, taskId: $taskId) {
      assets
      attachments {
        bucket
        key
        region
        fileName
      }
      comment
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      fieldId
      id
      taskId
      assetId
      tenantId
      users
      isDeleted
      autoGenerated
    }
  }
`;
export const getDeltaCommentsByTaskId = /* GraphQL */ `
  query GetDeltaCommentsByTaskId(
    $size: Int
    $taskId: String!
    $lastSync: AWSTimestamp
  ) {
    getDeltaCommentsByTaskId(
      size: $size
      taskId: $taskId
      lastSync: $lastSync
    ) {
      assets
      attachments {
        bucket
        key
        region
        fileName
      }
      comment
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      fieldId
      id
      taskId
      assetId
      tenantId
      users
      isDeleted
      autoGenerated
    }
  }
`;
export const getFeedsByAreas = /* GraphQL */ `
  query GetFeedsByAreas(
    $size: Int
    $areas: [String]
    $startTime: AWSTimestamp
  ) {
    getFeedsByAreas(size: $size, areas: $areas, startTime: $startTime) {
      data
      fieldId
      id
      tenantId
      userId
      areaIds
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      isDeleted
    }
  }
`;
export const getDeltaFeedsByAreas = /* GraphQL */ `
  query GetDeltaFeedsByAreas(
    $size: Int
    $areas: [String]
    $lastSync: AWSTimestamp
  ) {
    getDeltaFeedsByAreas(size: $size, areas: $areas, lastSync: $lastSync) {
      data
      fieldId
      id
      tenantId
      userId
      areaIds
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      isDeleted
    }
  }
`;
export const searchEntityAttributes = /* GraphQL */ `
  query SearchEntityAttributes($limit: Int, $nextToken: Int) {
    searchEntityAttributes(limit: $limit, nextToken: $nextToken) {
      total
      items {
        id
        tenantId
        xid
        sourceSystem
        attributeDisplayName
        assetType
        attributeType
        attributeName
        isDeleted
      }
      nextToken
    }
  }
`;
export const searchAssets = /* GraphQL */ `
  query SearchAssets(
    $filter: SearchableAssetFilterInput
    $sort: SearchableAssetSortInput
    $limit: Int
    $nextToken: Int
  ) {
    searchAssets(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      total
      items {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      nextToken
    }
  }
`;
export const searchTeams = /* GraphQL */ `
  query SearchTeams(
    $filter: SearchableTeamFilterInput
    $sort: SearchableTeamSortInput
    $limit: Int
    $nextToken: Int
  ) {
    searchTeams(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      total
      items {
        id
        name
        tenantId
        fieldId
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        aws_ds
        allowedTaskTypeCreateGroups {
          id
          name
        }
      }
      nextToken
    }
  }
`;
export const searchTaskTypes = /* GraphQL */ `
  query SearchTaskTypes(
    $filter: SearchableTaskTypeFilterInput
    $sort: SearchableTaskTypeSortInput
    $limit: Int
    $nextToken: Int
  ) {
    searchTaskTypes(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      total
      items {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      nextToken
    }
  }
`;
export const searchUsers = /* GraphQL */ `
  query SearchUsers(
    $filter: SearchableUserFilterInput
    $sort: SearchableUserSortInput
    $limit: Int
    $nextToken: Int
  ) {
    searchUsers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      total
      items {
        id
        xid
        sourceSystem
        tenantId
        fieldId
        userName
        firstName
        lastName
        email
        phone
        deviceId
        startLatitude
        startLongitude
        endLatitude
        endLongitude
        currentLatitude
        currentLongitude
        shiftStartTime
        shiftEndTime
        startStopId
        endStopId
        contractHourlyRate
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        activityStatus
        hitch {
          hitchStartDate
          hitchPattern {
            hitchWorkDays
            hitchOffDays
            sortOrder
          }
        }
        teams {
          userId
          teamId
          isDeleted
          isTeamLead
          isTeamMember
        }
        roles {
          userId
          roleId
          isDeleted
        }
        contacts
        defaultContact
        offDays
        onDays
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        isDeleted
        timeZone
        aws_ds
        locationUpdatedOn
        deviceMetadata
        vendorId
        aclQualifiedId
        contractInfoId
        businessTitle
        joyn2Roles
        signatureObject {
          bucket
          key
          region
          fileName
        }
        approver
        iscreatedFromFSM
        cognitoUserName
        mobileSettings
        isEquipmentResource
        operatorId
        accessCreatedBy
        shareCreatedWith
        allowReassignmentOnMobile
      }
      nextToken
    }
  }
`;
export const searchPicklists = /* GraphQL */ `
  query SearchPicklists(
    $filter: SearchablePicklistFilterInput
    $sort: SearchablePicklistSortInput
    $limit: Int
    $nextToken: Int
  ) {
    searchPicklists(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      total
      items {
        createdBy
        createdOn
        desc
        id
        modifiedBy
        modifiedOn
        name
        options
        parentId
        tenantId
        xid
        isCustomizable
        displayName
      }
      nextToken
    }
  }
`;
export const getEnterpriseConfig = /* GraphQL */ `
  query GetEnterpriseConfig($providerName: String!) {
    getEnterpriseConfig(providerName: $providerName) {
      id
      providerName
      enterpriseConfig {
        clientId
        fdgBaseUrl
        providerId
        redirectUrl
      }
    }
  }
`;
export const getProviderIdFromName = /* GraphQL */ `
  query GetProviderIdFromName($providerName: String!) {
    getProviderIdFromName(providerName: $providerName)
  }
`;
export const getAssetByAreasPaginated = /* GraphQL */ `
  query GetAssetByAreasPaginated(
    $areas: [String]
    $nextToken: String
    $size: Int
  ) {
    getAssetByAreasPaginated(
      areas: $areas
      nextToken: $nextToken
      size: $size
    ) {
      total
      items {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      nextToken
    }
  }
`;
export const getAssetByAreasAndTypesPaginated = /* GraphQL */ `
  query GetAssetByAreasAndTypesPaginated(
    $areas: [String]
    $types: [String]
    $nextToken: String
    $size: Int
  ) {
    getAssetByAreasAndTypesPaginated(
      areas: $areas
      types: $types
      nextToken: $nextToken
      size: $size
    ) {
      total
      items {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      nextToken
    }
  }
`;
export const getAssetsByFieldAndTypesPaginated = /* GraphQL */ `
  query GetAssetsByFieldAndTypesPaginated(
    $fieldId: String!
    $types: [String]
    $nextToken: String
    $size: Int
  ) {
    getAssetsByFieldAndTypesPaginated(
      fieldId: $fieldId
      types: $types
      nextToken: $nextToken
      size: $size
    ) {
      total
      items {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      nextToken
    }
  }
`;
export const getTasksByAreasPaginated = /* GraphQL */ `
  query GetTasksByAreasPaginated(
    $areas: [String]
    $startTimeLessThan: AWSDateTime
    $startTimeGreaterThan: AWSDateTime
    $nextToken: String
    $size: Int
  ) {
    getTasksByAreasPaginated(
      areas: $areas
      startTimeLessThan: $startTimeLessThan
      startTimeGreaterThan: $startTimeGreaterThan
      nextToken: $nextToken
      size: $size
    ) {
      total
      items {
        approvedBy
        approvedOn
        asset {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        assetId
        assignee
        assigneeIds {
          assigneeId
          sequence
          isDeleted
          isAccepted
          acceptedOn
          vendorId
          operatorId
        }
        assignedOn
        attachments {
          bucket
          key
          region
          fileName
        }
        completedOn
        createdOn
        createdBy
        data
        duration
        endTime
        eventSource
        isRecurring
        fieldId
        id
        isHardAssignee
        isPlanned
        recurrenceInactive
        priority
        schedule {
          rrule
          startDate
          endDate
          recurrencePattern
          type
          displayUptoDays
          allowPileups
          overwriteEditedOccurrences
        }
        sourceRecurringTaskId
        originalRecurrenceDate
        deletedForRecurrenceDates
        isHardStartTime
        startTime
        status
        taskType {
          id
          duration
          priority
          score
          increment
          name
          schema
          teamId
          tenantId
          fieldId
          isParent
          autoApprove
          workflowVersions {
            version
            workflowSteps {
              workflowStepId
              taskTypeId
              dependsOn
              immediateNextTo
              sameAssigneeAs
              sameStartTimeAs
              formSectionId
              preferredLocationTypeId
              priorityTemplate
              assigneeIds
              sameLocationAs
              autoResolveDependsOn
            }
          }
          publishedVersion
          createdOn
          createdBy
          modifiedOn
          modifiedBy
          isDeleted
          needAcceptance
          enforceTimeSpent
          enforceComment
          enableReassign
          enableAutoAssign
          hasFormAttributes
          isLinkable
          certificates {
            id
            name
            isExpirable
            expiryDate
          }
          skillLevel {
            id
            name
            value
          }
          resolveOnArchive
          partsPicklist
          formSchemaId
          approvalMatrix
          disableCreateOnMobile
          disableAssignOnMobile
          disablePriorityOnMobile
          disableWorkOrderOnMobile
          disableDateOnMobile
          disableAssetOnMobile
          resolveOnGeofence
          excludeByRoutingEngine
          disablePrioritySelectionOnMobile
          disableEditingResolvedOnMobile
          taskTypeCode
          generateMultiple
          globalAttributes
          reminder {
            enableReminder
            reminderTime {
              days
              hours
              minutes
            }
          }
          attachmentIds
          instructionIds
          notification {
            notificationProfile
            notificationConfig {
              actionType
              userTypeForEmail
              userTypeForPushNotification
              sectionsToIncludeInEmail
            }
          }
          notificationProfile
          actionsEnabled
          userType
          fullManualMode
          singleActiveTask
          mandatoryWatcherGroups
          priorityTemplate
          priorityAlias
          rt_id
          needEquipment
          mandatoryAssignee
          autoAssignFirstChildToCreator
          triggerTasksUsingRules
          groups {
            id
            name
          }
          watcherGroupConfig {
            entityId
            entityPicklistWatcherGroupMappingId
            entityType
          }
          generateMultipleLabelName
          isDynamicParentChild
          rollupGlobalAttributes
          allowAssetLevelsInfo
          allowTaskCreationWithResolvedStatus
          autoResolveFirstTask
          defaultLocationTask
          allowedTeamsAsWatchers
        }
        taskTypeId
        tenantId
        parentTaskId
        workflowVersion
        workflowStepId
        modifiedOn
        modifiedBy
        dependsOn
        immediateNextTo
        sameAssigneeAs
        sameStartTimeAs
        sameLocationAs
        isDeleted
        delayMinutes
        resolvedBy
        resolvedOn
        linkedTaskIds
        template
        approvalStatus
        watcherIds
        parts {
          picklistId
          picklistOptionId
          quantity
        }
        formSchemaId
        formSectionId
        globalAttributes
        approvalInfo
        approverIds
        isApprovalWorkflow
        requestorIds
        onlyAllowManualScoreUpdate
        rejectedIds {
          id
          rejectedOn
        }
        scheduled
        taskNumber
        isTaskCopied
        watcherGroupIds
        timeToNextPriority
        isTaskLocked
        draftState
        readingId
        rulesEvaluated
        triggeredSourceTaskId
        generateMultiple
        copyGenerateMultipleAssignee
        nightShiftStartTime
        assetLevelsInfo
        nextRecurrenceDate
        prevRecurrenceDate
        statusAudit
        priorityScore
        score
        increment
      }
      nextToken
    }
  }
`;
export const getTasksByFieldPaginated = /* GraphQL */ `
  query GetTasksByFieldPaginated(
    $fieldId: String
    $startTimeLessThan: AWSDateTime
    $startTimeGreaterThan: AWSDateTime
    $nextToken: String
    $size: Int
  ) {
    getTasksByFieldPaginated(
      fieldId: $fieldId
      startTimeLessThan: $startTimeLessThan
      startTimeGreaterThan: $startTimeGreaterThan
      nextToken: $nextToken
      size: $size
    ) {
      total
      items {
        approvedBy
        approvedOn
        asset {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        assetId
        assignee
        assigneeIds {
          assigneeId
          sequence
          isDeleted
          isAccepted
          acceptedOn
          vendorId
          operatorId
        }
        assignedOn
        attachments {
          bucket
          key
          region
          fileName
        }
        completedOn
        createdOn
        createdBy
        data
        duration
        endTime
        eventSource
        isRecurring
        fieldId
        id
        isHardAssignee
        isPlanned
        recurrenceInactive
        priority
        schedule {
          rrule
          startDate
          endDate
          recurrencePattern
          type
          displayUptoDays
          allowPileups
          overwriteEditedOccurrences
        }
        sourceRecurringTaskId
        originalRecurrenceDate
        deletedForRecurrenceDates
        isHardStartTime
        startTime
        status
        taskType {
          id
          duration
          priority
          score
          increment
          name
          schema
          teamId
          tenantId
          fieldId
          isParent
          autoApprove
          workflowVersions {
            version
            workflowSteps {
              workflowStepId
              taskTypeId
              dependsOn
              immediateNextTo
              sameAssigneeAs
              sameStartTimeAs
              formSectionId
              preferredLocationTypeId
              priorityTemplate
              assigneeIds
              sameLocationAs
              autoResolveDependsOn
            }
          }
          publishedVersion
          createdOn
          createdBy
          modifiedOn
          modifiedBy
          isDeleted
          needAcceptance
          enforceTimeSpent
          enforceComment
          enableReassign
          enableAutoAssign
          hasFormAttributes
          isLinkable
          certificates {
            id
            name
            isExpirable
            expiryDate
          }
          skillLevel {
            id
            name
            value
          }
          resolveOnArchive
          partsPicklist
          formSchemaId
          approvalMatrix
          disableCreateOnMobile
          disableAssignOnMobile
          disablePriorityOnMobile
          disableWorkOrderOnMobile
          disableDateOnMobile
          disableAssetOnMobile
          resolveOnGeofence
          excludeByRoutingEngine
          disablePrioritySelectionOnMobile
          disableEditingResolvedOnMobile
          taskTypeCode
          generateMultiple
          globalAttributes
          reminder {
            enableReminder
            reminderTime {
              days
              hours
              minutes
            }
          }
          attachmentIds
          instructionIds
          notification {
            notificationProfile
            notificationConfig {
              actionType
              userTypeForEmail
              userTypeForPushNotification
              sectionsToIncludeInEmail
            }
          }
          notificationProfile
          actionsEnabled
          userType
          fullManualMode
          singleActiveTask
          mandatoryWatcherGroups
          priorityTemplate
          priorityAlias
          rt_id
          needEquipment
          mandatoryAssignee
          autoAssignFirstChildToCreator
          triggerTasksUsingRules
          groups {
            id
            name
          }
          watcherGroupConfig {
            entityId
            entityPicklistWatcherGroupMappingId
            entityType
          }
          generateMultipleLabelName
          isDynamicParentChild
          rollupGlobalAttributes
          allowAssetLevelsInfo
          allowTaskCreationWithResolvedStatus
          autoResolveFirstTask
          defaultLocationTask
          allowedTeamsAsWatchers
        }
        taskTypeId
        tenantId
        parentTaskId
        workflowVersion
        workflowStepId
        modifiedOn
        modifiedBy
        dependsOn
        immediateNextTo
        sameAssigneeAs
        sameStartTimeAs
        sameLocationAs
        isDeleted
        delayMinutes
        resolvedBy
        resolvedOn
        linkedTaskIds
        template
        approvalStatus
        watcherIds
        parts {
          picklistId
          picklistOptionId
          quantity
        }
        formSchemaId
        formSectionId
        globalAttributes
        approvalInfo
        approverIds
        isApprovalWorkflow
        requestorIds
        onlyAllowManualScoreUpdate
        rejectedIds {
          id
          rejectedOn
        }
        scheduled
        taskNumber
        isTaskCopied
        watcherGroupIds
        timeToNextPriority
        isTaskLocked
        draftState
        readingId
        rulesEvaluated
        triggeredSourceTaskId
        generateMultiple
        copyGenerateMultipleAssignee
        nightShiftStartTime
        assetLevelsInfo
        nextRecurrenceDate
        prevRecurrenceDate
        statusAudit
        priorityScore
        score
        increment
      }
      nextToken
    }
  }
`;
export const getTasksByUsersPaginated = /* GraphQL */ `
  query GetTasksByUsersPaginated(
    $users: [String]
    $startTimeLessThan: AWSDateTime
    $startTimeGreaterThan: AWSDateTime
    $nextToken: String
    $size: Int
  ) {
    getTasksByUsersPaginated(
      users: $users
      startTimeLessThan: $startTimeLessThan
      startTimeGreaterThan: $startTimeGreaterThan
      nextToken: $nextToken
      size: $size
    ) {
      total
      items {
        approvedBy
        approvedOn
        asset {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        assetId
        assignee
        assigneeIds {
          assigneeId
          sequence
          isDeleted
          isAccepted
          acceptedOn
          vendorId
          operatorId
        }
        assignedOn
        attachments {
          bucket
          key
          region
          fileName
        }
        completedOn
        createdOn
        createdBy
        data
        duration
        endTime
        eventSource
        isRecurring
        fieldId
        id
        isHardAssignee
        isPlanned
        recurrenceInactive
        priority
        schedule {
          rrule
          startDate
          endDate
          recurrencePattern
          type
          displayUptoDays
          allowPileups
          overwriteEditedOccurrences
        }
        sourceRecurringTaskId
        originalRecurrenceDate
        deletedForRecurrenceDates
        isHardStartTime
        startTime
        status
        taskType {
          id
          duration
          priority
          score
          increment
          name
          schema
          teamId
          tenantId
          fieldId
          isParent
          autoApprove
          workflowVersions {
            version
            workflowSteps {
              workflowStepId
              taskTypeId
              dependsOn
              immediateNextTo
              sameAssigneeAs
              sameStartTimeAs
              formSectionId
              preferredLocationTypeId
              priorityTemplate
              assigneeIds
              sameLocationAs
              autoResolveDependsOn
            }
          }
          publishedVersion
          createdOn
          createdBy
          modifiedOn
          modifiedBy
          isDeleted
          needAcceptance
          enforceTimeSpent
          enforceComment
          enableReassign
          enableAutoAssign
          hasFormAttributes
          isLinkable
          certificates {
            id
            name
            isExpirable
            expiryDate
          }
          skillLevel {
            id
            name
            value
          }
          resolveOnArchive
          partsPicklist
          formSchemaId
          approvalMatrix
          disableCreateOnMobile
          disableAssignOnMobile
          disablePriorityOnMobile
          disableWorkOrderOnMobile
          disableDateOnMobile
          disableAssetOnMobile
          resolveOnGeofence
          excludeByRoutingEngine
          disablePrioritySelectionOnMobile
          disableEditingResolvedOnMobile
          taskTypeCode
          generateMultiple
          globalAttributes
          reminder {
            enableReminder
            reminderTime {
              days
              hours
              minutes
            }
          }
          attachmentIds
          instructionIds
          notification {
            notificationProfile
            notificationConfig {
              actionType
              userTypeForEmail
              userTypeForPushNotification
              sectionsToIncludeInEmail
            }
          }
          notificationProfile
          actionsEnabled
          userType
          fullManualMode
          singleActiveTask
          mandatoryWatcherGroups
          priorityTemplate
          priorityAlias
          rt_id
          needEquipment
          mandatoryAssignee
          autoAssignFirstChildToCreator
          triggerTasksUsingRules
          groups {
            id
            name
          }
          watcherGroupConfig {
            entityId
            entityPicklistWatcherGroupMappingId
            entityType
          }
          generateMultipleLabelName
          isDynamicParentChild
          rollupGlobalAttributes
          allowAssetLevelsInfo
          allowTaskCreationWithResolvedStatus
          autoResolveFirstTask
          defaultLocationTask
          allowedTeamsAsWatchers
        }
        taskTypeId
        tenantId
        parentTaskId
        workflowVersion
        workflowStepId
        modifiedOn
        modifiedBy
        dependsOn
        immediateNextTo
        sameAssigneeAs
        sameStartTimeAs
        sameLocationAs
        isDeleted
        delayMinutes
        resolvedBy
        resolvedOn
        linkedTaskIds
        template
        approvalStatus
        watcherIds
        parts {
          picklistId
          picklistOptionId
          quantity
        }
        formSchemaId
        formSectionId
        globalAttributes
        approvalInfo
        approverIds
        isApprovalWorkflow
        requestorIds
        onlyAllowManualScoreUpdate
        rejectedIds {
          id
          rejectedOn
        }
        scheduled
        taskNumber
        isTaskCopied
        watcherGroupIds
        timeToNextPriority
        isTaskLocked
        draftState
        readingId
        rulesEvaluated
        triggeredSourceTaskId
        generateMultiple
        copyGenerateMultipleAssignee
        nightShiftStartTime
        assetLevelsInfo
        nextRecurrenceDate
        prevRecurrenceDate
        statusAudit
        priorityScore
        score
        increment
      }
      nextToken
    }
  }
`;
export const getTasksByTaskTypeIdsPaginated = /* GraphQL */ `
  query GetTasksByTaskTypeIdsPaginated(
    $taskTypeIds: [String]
    $startTimeLessThan: AWSDateTime
    $startTimeGreaterThan: AWSDateTime
    $nextToken: String
    $size: Int
  ) {
    getTasksByTaskTypeIdsPaginated(
      taskTypeIds: $taskTypeIds
      startTimeLessThan: $startTimeLessThan
      startTimeGreaterThan: $startTimeGreaterThan
      nextToken: $nextToken
      size: $size
    ) {
      total
      items {
        approvedBy
        approvedOn
        asset {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        assetId
        assignee
        assigneeIds {
          assigneeId
          sequence
          isDeleted
          isAccepted
          acceptedOn
          vendorId
          operatorId
        }
        assignedOn
        attachments {
          bucket
          key
          region
          fileName
        }
        completedOn
        createdOn
        createdBy
        data
        duration
        endTime
        eventSource
        isRecurring
        fieldId
        id
        isHardAssignee
        isPlanned
        recurrenceInactive
        priority
        schedule {
          rrule
          startDate
          endDate
          recurrencePattern
          type
          displayUptoDays
          allowPileups
          overwriteEditedOccurrences
        }
        sourceRecurringTaskId
        originalRecurrenceDate
        deletedForRecurrenceDates
        isHardStartTime
        startTime
        status
        taskType {
          id
          duration
          priority
          score
          increment
          name
          schema
          teamId
          tenantId
          fieldId
          isParent
          autoApprove
          workflowVersions {
            version
            workflowSteps {
              workflowStepId
              taskTypeId
              dependsOn
              immediateNextTo
              sameAssigneeAs
              sameStartTimeAs
              formSectionId
              preferredLocationTypeId
              priorityTemplate
              assigneeIds
              sameLocationAs
              autoResolveDependsOn
            }
          }
          publishedVersion
          createdOn
          createdBy
          modifiedOn
          modifiedBy
          isDeleted
          needAcceptance
          enforceTimeSpent
          enforceComment
          enableReassign
          enableAutoAssign
          hasFormAttributes
          isLinkable
          certificates {
            id
            name
            isExpirable
            expiryDate
          }
          skillLevel {
            id
            name
            value
          }
          resolveOnArchive
          partsPicklist
          formSchemaId
          approvalMatrix
          disableCreateOnMobile
          disableAssignOnMobile
          disablePriorityOnMobile
          disableWorkOrderOnMobile
          disableDateOnMobile
          disableAssetOnMobile
          resolveOnGeofence
          excludeByRoutingEngine
          disablePrioritySelectionOnMobile
          disableEditingResolvedOnMobile
          taskTypeCode
          generateMultiple
          globalAttributes
          reminder {
            enableReminder
            reminderTime {
              days
              hours
              minutes
            }
          }
          attachmentIds
          instructionIds
          notification {
            notificationProfile
            notificationConfig {
              actionType
              userTypeForEmail
              userTypeForPushNotification
              sectionsToIncludeInEmail
            }
          }
          notificationProfile
          actionsEnabled
          userType
          fullManualMode
          singleActiveTask
          mandatoryWatcherGroups
          priorityTemplate
          priorityAlias
          rt_id
          needEquipment
          mandatoryAssignee
          autoAssignFirstChildToCreator
          triggerTasksUsingRules
          groups {
            id
            name
          }
          watcherGroupConfig {
            entityId
            entityPicklistWatcherGroupMappingId
            entityType
          }
          generateMultipleLabelName
          isDynamicParentChild
          rollupGlobalAttributes
          allowAssetLevelsInfo
          allowTaskCreationWithResolvedStatus
          autoResolveFirstTask
          defaultLocationTask
          allowedTeamsAsWatchers
        }
        taskTypeId
        tenantId
        parentTaskId
        workflowVersion
        workflowStepId
        modifiedOn
        modifiedBy
        dependsOn
        immediateNextTo
        sameAssigneeAs
        sameStartTimeAs
        sameLocationAs
        isDeleted
        delayMinutes
        resolvedBy
        resolvedOn
        linkedTaskIds
        template
        approvalStatus
        watcherIds
        parts {
          picklistId
          picklistOptionId
          quantity
        }
        formSchemaId
        formSectionId
        globalAttributes
        approvalInfo
        approverIds
        isApprovalWorkflow
        requestorIds
        onlyAllowManualScoreUpdate
        rejectedIds {
          id
          rejectedOn
        }
        scheduled
        taskNumber
        isTaskCopied
        watcherGroupIds
        timeToNextPriority
        isTaskLocked
        draftState
        readingId
        rulesEvaluated
        triggeredSourceTaskId
        generateMultiple
        copyGenerateMultipleAssignee
        nightShiftStartTime
        assetLevelsInfo
        nextRecurrenceDate
        prevRecurrenceDate
        statusAudit
        priorityScore
        score
        increment
      }
      nextToken
    }
  }
`;
export const getTasksByAssetIdPaginated = /* GraphQL */ `
  query GetTasksByAssetIdPaginated(
    $assetId: String!
    $startTimeLessThan: AWSDateTime
    $startTimeGreaterThan: AWSDateTime
    $nextToken: String
    $size: Int
  ) {
    getTasksByAssetIdPaginated(
      assetId: $assetId
      startTimeLessThan: $startTimeLessThan
      startTimeGreaterThan: $startTimeGreaterThan
      nextToken: $nextToken
      size: $size
    ) {
      total
      items {
        approvedBy
        approvedOn
        asset {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        assetId
        assignee
        assigneeIds {
          assigneeId
          sequence
          isDeleted
          isAccepted
          acceptedOn
          vendorId
          operatorId
        }
        assignedOn
        attachments {
          bucket
          key
          region
          fileName
        }
        completedOn
        createdOn
        createdBy
        data
        duration
        endTime
        eventSource
        isRecurring
        fieldId
        id
        isHardAssignee
        isPlanned
        recurrenceInactive
        priority
        schedule {
          rrule
          startDate
          endDate
          recurrencePattern
          type
          displayUptoDays
          allowPileups
          overwriteEditedOccurrences
        }
        sourceRecurringTaskId
        originalRecurrenceDate
        deletedForRecurrenceDates
        isHardStartTime
        startTime
        status
        taskType {
          id
          duration
          priority
          score
          increment
          name
          schema
          teamId
          tenantId
          fieldId
          isParent
          autoApprove
          workflowVersions {
            version
            workflowSteps {
              workflowStepId
              taskTypeId
              dependsOn
              immediateNextTo
              sameAssigneeAs
              sameStartTimeAs
              formSectionId
              preferredLocationTypeId
              priorityTemplate
              assigneeIds
              sameLocationAs
              autoResolveDependsOn
            }
          }
          publishedVersion
          createdOn
          createdBy
          modifiedOn
          modifiedBy
          isDeleted
          needAcceptance
          enforceTimeSpent
          enforceComment
          enableReassign
          enableAutoAssign
          hasFormAttributes
          isLinkable
          certificates {
            id
            name
            isExpirable
            expiryDate
          }
          skillLevel {
            id
            name
            value
          }
          resolveOnArchive
          partsPicklist
          formSchemaId
          approvalMatrix
          disableCreateOnMobile
          disableAssignOnMobile
          disablePriorityOnMobile
          disableWorkOrderOnMobile
          disableDateOnMobile
          disableAssetOnMobile
          resolveOnGeofence
          excludeByRoutingEngine
          disablePrioritySelectionOnMobile
          disableEditingResolvedOnMobile
          taskTypeCode
          generateMultiple
          globalAttributes
          reminder {
            enableReminder
            reminderTime {
              days
              hours
              minutes
            }
          }
          attachmentIds
          instructionIds
          notification {
            notificationProfile
            notificationConfig {
              actionType
              userTypeForEmail
              userTypeForPushNotification
              sectionsToIncludeInEmail
            }
          }
          notificationProfile
          actionsEnabled
          userType
          fullManualMode
          singleActiveTask
          mandatoryWatcherGroups
          priorityTemplate
          priorityAlias
          rt_id
          needEquipment
          mandatoryAssignee
          autoAssignFirstChildToCreator
          triggerTasksUsingRules
          groups {
            id
            name
          }
          watcherGroupConfig {
            entityId
            entityPicklistWatcherGroupMappingId
            entityType
          }
          generateMultipleLabelName
          isDynamicParentChild
          rollupGlobalAttributes
          allowAssetLevelsInfo
          allowTaskCreationWithResolvedStatus
          autoResolveFirstTask
          defaultLocationTask
          allowedTeamsAsWatchers
        }
        taskTypeId
        tenantId
        parentTaskId
        workflowVersion
        workflowStepId
        modifiedOn
        modifiedBy
        dependsOn
        immediateNextTo
        sameAssigneeAs
        sameStartTimeAs
        sameLocationAs
        isDeleted
        delayMinutes
        resolvedBy
        resolvedOn
        linkedTaskIds
        template
        approvalStatus
        watcherIds
        parts {
          picklistId
          picklistOptionId
          quantity
        }
        formSchemaId
        formSectionId
        globalAttributes
        approvalInfo
        approverIds
        isApprovalWorkflow
        requestorIds
        onlyAllowManualScoreUpdate
        rejectedIds {
          id
          rejectedOn
        }
        scheduled
        taskNumber
        isTaskCopied
        watcherGroupIds
        timeToNextPriority
        isTaskLocked
        draftState
        readingId
        rulesEvaluated
        triggeredSourceTaskId
        generateMultiple
        copyGenerateMultipleAssignee
        nightShiftStartTime
        assetLevelsInfo
        nextRecurrenceDate
        prevRecurrenceDate
        statusAudit
        priorityScore
        score
        increment
      }
      nextToken
    }
  }
`;
export const getTasksByAssetsPaginated = /* GraphQL */ `
  query GetTasksByAssetsPaginated(
    $assets: [String]
    $startTimeLessThan: AWSDateTime
    $startTimeGreaterThan: AWSDateTime
    $nextToken: String
    $size: Int
  ) {
    getTasksByAssetsPaginated(
      assets: $assets
      startTimeLessThan: $startTimeLessThan
      startTimeGreaterThan: $startTimeGreaterThan
      nextToken: $nextToken
      size: $size
    ) {
      total
      items {
        approvedBy
        approvedOn
        asset {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        assetId
        assignee
        assigneeIds {
          assigneeId
          sequence
          isDeleted
          isAccepted
          acceptedOn
          vendorId
          operatorId
        }
        assignedOn
        attachments {
          bucket
          key
          region
          fileName
        }
        completedOn
        createdOn
        createdBy
        data
        duration
        endTime
        eventSource
        isRecurring
        fieldId
        id
        isHardAssignee
        isPlanned
        recurrenceInactive
        priority
        schedule {
          rrule
          startDate
          endDate
          recurrencePattern
          type
          displayUptoDays
          allowPileups
          overwriteEditedOccurrences
        }
        sourceRecurringTaskId
        originalRecurrenceDate
        deletedForRecurrenceDates
        isHardStartTime
        startTime
        status
        taskType {
          id
          duration
          priority
          score
          increment
          name
          schema
          teamId
          tenantId
          fieldId
          isParent
          autoApprove
          workflowVersions {
            version
            workflowSteps {
              workflowStepId
              taskTypeId
              dependsOn
              immediateNextTo
              sameAssigneeAs
              sameStartTimeAs
              formSectionId
              preferredLocationTypeId
              priorityTemplate
              assigneeIds
              sameLocationAs
              autoResolveDependsOn
            }
          }
          publishedVersion
          createdOn
          createdBy
          modifiedOn
          modifiedBy
          isDeleted
          needAcceptance
          enforceTimeSpent
          enforceComment
          enableReassign
          enableAutoAssign
          hasFormAttributes
          isLinkable
          certificates {
            id
            name
            isExpirable
            expiryDate
          }
          skillLevel {
            id
            name
            value
          }
          resolveOnArchive
          partsPicklist
          formSchemaId
          approvalMatrix
          disableCreateOnMobile
          disableAssignOnMobile
          disablePriorityOnMobile
          disableWorkOrderOnMobile
          disableDateOnMobile
          disableAssetOnMobile
          resolveOnGeofence
          excludeByRoutingEngine
          disablePrioritySelectionOnMobile
          disableEditingResolvedOnMobile
          taskTypeCode
          generateMultiple
          globalAttributes
          reminder {
            enableReminder
            reminderTime {
              days
              hours
              minutes
            }
          }
          attachmentIds
          instructionIds
          notification {
            notificationProfile
            notificationConfig {
              actionType
              userTypeForEmail
              userTypeForPushNotification
              sectionsToIncludeInEmail
            }
          }
          notificationProfile
          actionsEnabled
          userType
          fullManualMode
          singleActiveTask
          mandatoryWatcherGroups
          priorityTemplate
          priorityAlias
          rt_id
          needEquipment
          mandatoryAssignee
          autoAssignFirstChildToCreator
          triggerTasksUsingRules
          groups {
            id
            name
          }
          watcherGroupConfig {
            entityId
            entityPicklistWatcherGroupMappingId
            entityType
          }
          generateMultipleLabelName
          isDynamicParentChild
          rollupGlobalAttributes
          allowAssetLevelsInfo
          allowTaskCreationWithResolvedStatus
          autoResolveFirstTask
          defaultLocationTask
          allowedTeamsAsWatchers
        }
        taskTypeId
        tenantId
        parentTaskId
        workflowVersion
        workflowStepId
        modifiedOn
        modifiedBy
        dependsOn
        immediateNextTo
        sameAssigneeAs
        sameStartTimeAs
        sameLocationAs
        isDeleted
        delayMinutes
        resolvedBy
        resolvedOn
        linkedTaskIds
        template
        approvalStatus
        watcherIds
        parts {
          picklistId
          picklistOptionId
          quantity
        }
        formSchemaId
        formSectionId
        globalAttributes
        approvalInfo
        approverIds
        isApprovalWorkflow
        requestorIds
        onlyAllowManualScoreUpdate
        rejectedIds {
          id
          rejectedOn
        }
        scheduled
        taskNumber
        isTaskCopied
        watcherGroupIds
        timeToNextPriority
        isTaskLocked
        draftState
        readingId
        rulesEvaluated
        triggeredSourceTaskId
        generateMultiple
        copyGenerateMultipleAssignee
        nightShiftStartTime
        assetLevelsInfo
        nextRecurrenceDate
        prevRecurrenceDate
        statusAudit
        priorityScore
        score
        increment
      }
      nextToken
    }
  }
`;
export const getFeedsByAreasPaginated = /* GraphQL */ `
  query GetFeedsByAreasPaginated(
    $areas: [String]
    $startTimeLessThan: AWSDateTime
    $startTimeGreaterThan: AWSDateTime
    $nextToken: String
    $size: Int
  ) {
    getFeedsByAreasPaginated(
      areas: $areas
      startTimeLessThan: $startTimeLessThan
      startTimeGreaterThan: $startTimeGreaterThan
      nextToken: $nextToken
      size: $size
    ) {
      total
      items {
        data
        fieldId
        id
        tenantId
        userId
        areaIds
        createdOn
        createdBy
        modifiedBy
        modifiedOn
        isDeleted
      }
      nextToken
    }
  }
`;
export const getRouteEngineHistoryByField = /* GraphQL */ `
  query GetRouteEngineHistoryByField(
    $fieldId: String!
    $startDate: AWSDateTime!
    $size: Int
    $nextToken: String
  ) {
    getRouteEngineHistoryByField(
      fieldId: $fieldId
      startDate: $startDate
      size: $size
      nextToken: $nextToken
    ) {
      total
      items {
        id
        tenantId
        data
        createdBy
        modifiedBy
        createdOn
        entity
        successful
      }
      nextToken
    }
  }
`;
export const getCommentsByAssetIdPaginated = /* GraphQL */ `
  query GetCommentsByAssetIdPaginated(
    $size: Int
    $nextToken: String
    $assetId: String!
  ) {
    getCommentsByAssetIdPaginated(
      size: $size
      nextToken: $nextToken
      assetId: $assetId
    ) {
      total
      items {
        assets
        attachments {
          bucket
          key
          region
          fileName
        }
        comment
        createdOn
        createdBy
        modifiedBy
        modifiedOn
        fieldId
        id
        taskId
        assetId
        tenantId
        users
        isDeleted
        autoGenerated
      }
      nextToken
    }
  }
`;
export const getPicklist = /* GraphQL */ `
  query GetPicklist($id: ID!) {
    getPicklist(id: $id) {
      createdBy
      createdOn
      desc
      id
      modifiedBy
      modifiedOn
      name
      options
      parentId
      tenantId
      xid
      isCustomizable
      displayName
    }
  }
`;
export const getRoles = /* GraphQL */ `
  query GetRoles {
    getRoles {
      items {
        id
        name
        access
        createdBy
        createdOn
        modifiedBy
        modifiedOn
      }
      nextToken
      scannedCount
    }
  }
`;
